module.exports = __webpack_public_path__ + "media/ORETACHI(俺たち).b066f054.mp3";